<script setup lang="ts">
import KBtn from '@/components/btns/KBtn.vue';
</script>

<template>
  <KBtn
    size="xs"
    priority="info"
    :class="$style.exportAsPdfIconBtn2"
    icon="mdi-file-pdf-box"
    data-testid="exportAsPdfIconBtn"
    title="Export as PDF"
  />
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.exportAsPdfIconBtn {
}
</style>
